import BoardListContext from '@/context/apps/board/BoardListContext';
import _isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'next-i18next/pages';
import { useContext, type ReactNode } from 'react';
import type { UrlObject } from 'url';

import usePagination from '@/hooks/shared/usePagination';

import { getAppsBdOptions } from '@/data/apps/bd';

import NoList from '@/components/shared/ui/noList/NoList';
import Pagination from '@/components/shared/ui/pagination/Pagination';

import BoardListCategory from './BoardListCategory';

type Props = {
  /** Shown in place of the shared board wording when the list comes back empty */
  emptyTitleText?: ReactNode;
  filterPath?: string;
  getPageHref?: (page: number) => string | UrlObject;
};

export default function BoardListWithPagintaion({
  emptyTitleText,
  filterPath,
  getPageHref,
}: Props = {}) {
  const { t } = useTranslation('common');

  const { bdData, bcListData, bcatsData } = useContext(BoardListContext);

  const bdOptions = getAppsBdOptions(bdData.layout);

  const { paginationData, onPageChangeRouter } = usePagination({
    data: bcListData,
    sortingCount: bdData.take,
  });

  return (
    <div>
      {/* 카테고리 탭 */}
      {!_isEmpty(bcatsData) && (
        <BoardListCategory filterPath={filterPath} />
      )}

      {_isEmpty(bcListData) || _isEmpty(bcListData?.results) ? (
        <>
          {/* 리스트 탑 */}
          {/* TODO : 관련 기능 및 디자인 명세 필요. 아래는 임의 처리한 것임 */}
          {/* 처음 게시판 진입 시, 게시물이 아무것도 없으면 ListTop을 디스플레이 하지 않음 */}
          {/* 게시판 내 게시물은 있지만, 검색 후 검색결과가 없을 때는 ListTop이 없어지지 않도록 처리 */}
          {/* {q && (
            <BoardListTop
              showSummary={showSummary}
              showSearch={showSearch}
              showFilter={showFilter}
            />
          )} */}
          <NoList titleText={emptyTitleText ?? t('리스트가 없습니다.')} />
        </>
      ) : (
        <>
          {/* 리스트 탑 */}
          {/* <BoardListTop
            showSummary={showSummary}
            showSearch={showSearch}
            showFilter={showFilter}
          /> */}

          {/* 리스트 컨텐츠 */}
          {bdOptions?.list}

          {/* 리스트 페이지네이션 */}
          <Pagination
            className="[padding-top:60px]"
            forcePage={paginationData.currentPage}
            pageCount={paginationData.pageCount}
            pageRange={1}
            onPageChangeHandler={onPageChangeRouter}
            getPageHref={getPageHref}
          />
        </>
      )}
    </div>
  );
}
